import Vue from 'vue'

class WidgetDetector {
  detectTimeout = 15000

  constructor() {
    this.isInitialized = false
    this.hasTriplaWidgetPermission = true
  }

  setWidgetInitialized() {
    this.isInitialized = true
  }

  checkWidgetStatus() {
    if (window.top !== window) return

    setTimeout(() => {
      if (!this.hasTriplaWidgetPermission || this.isInitialized || !this.hasTriplabotCode()) return
      this.errorHandler()
    }, this.detectTimeout)
  }

  hasTriplabotCode() {
    const triplaScript = document.querySelector('script[src*="tripla.min.js"]')
    if (!triplaScript) return

    const code = triplaScript.getAttribute('data-triplabot-code')
    return !!code
  }

  errorHandler() {
    Vue.rollbar.error('Widget not detected')
  }
}

export default new WidgetDetector()
